// src/Home.js
import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import styled from 'styled-components';
import GlobalStyle from './GlobalStyles';

import Info from './pages/Info';
import Home from './pages/Home';
import NewsTitleAndDate from './pages/NewsTitleAndDate';
import DID from './pages/DID';
import DAO from './pages/DAO';
import RetroPGF from './pages/RetroPGF';
import Web3 from './pages/Web3';
import { Helmet } from "react-helmet-async";



const Container = styled.div`
  max-width: 100%;
  margin: 0px;
  padding: 0px;
  background-color:#000000;
`;


function App() {
  return (
  

    <Container>
      
    

      <Router>
        <Routes>
                  
            
            <Route path="/" element={<Home />} />
            <Route path="/info" element={<Info />} />
            <Route path="/newstitleanddate" element={<NewsTitleAndDate />} />
            <Route path="/did" element={<DID />} />
            <Route path="/dao" element={<DAO />} />
            <Route path="/retropgf" element={<RetroPGF />} />
            <Route path="/Web3" element={<Web3 />} />


        </Routes>
      </Router>
    </Container>
    
  );
}

export default App;
